import type {KitAdminState} from '@dv/kitadmin/models';
import {PERMISSION} from '@dv/shared/authentication/model';
import {GENERAL_SUFFIX} from '@dv/shared/roles';

export const HOLIDAY_REDUCTION = {
    name: 'base.personal.angestellte.main.holiday-reduction',
    url: '/holiday-reduction',
    data: {
        permission: PERMISSION.WORK_TIME_CONTROLLING.HOLIDAY_REDUCTION_VIEW + GENERAL_SUFFIX,
    },
} satisfies KitAdminState;
